import { Navigate } from "react-router-dom";
import { isGenericaToken, isTokenExpired } from "../services/Auth";

function AuthRoute({ children, redirectTo }) {
  const Autenticado = isGenericaToken() && !isTokenExpired();
  return Autenticado ? children : <Navigate to={redirectTo} />;
}

export default AuthRoute;
